import SwiperCore, {
    EffectCoverflow, Pagination
} from 'swiper';
import { Swiper, SwiperSlide } from "swiper/react";
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import pic2 from '../../images/Artboard 1 (1).jpg';
import pic3 from '../../images/Artboard 1.jpg';
import pic from '../../images/CQ2.png';
import pic1 from '../../images/WhatsApp Image 2021-03-20 at 8.53.55 PM.jpeg';
import styles from './Carouselcomp.module.css';

SwiperCore.use([EffectCoverflow, Pagination]);

const Carouselcomp = () => {
    return (
        <>
            <Swiper effect={'coverflow'} grabCursor={true} centeredSlides={true} loop={true} slidesPerView={3} coverflowEffect={{
                "rotate": 50,
                "stretch": 0,
                "depth": 100,
                "modifier": 1,
                "slideShadows": true
            }} pagination={{
                "clickable": true
            }} autoplay={{
                delay: '250'
            }} className="mySwiper">
                <SwiperSlide><img className={styles.imgcls} src={pic} alt="" /></SwiperSlide>
                <SwiperSlide><img className={styles.imgcls} src={pic1} alt="" /></SwiperSlide>
                <SwiperSlide><img className={styles.imgcls} src={pic2} alt="" /></SwiperSlide>
                <SwiperSlide><img className={styles.imgcls} src={pic3} alt="" /></SwiperSlide>
            </Swiper>
        </>
    );
};

export default Carouselcomp;